import { render, staticRenderFns } from "./UnsuspensionRequestStats.vue?vue&type=template&id=b84a2e04&"
import script from "./UnsuspensionRequestStats.vue?vue&type=script&lang=js&"
export * from "./UnsuspensionRequestStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports